import script from "./DoubleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__